// extracted by mini-css-extract-plugin
module.exports = {"notificationModalSelect":"_17qaK"};